@if (paymentData) {
  <div class="container">
    <!--Account Info redirect to dashboard page-->
    <div class="acc-info-btn">
      <gds-utility-action
        [data]="{
          icon: {
            iconName: 'left-arrow-v2',
          },
          label: pageLabels?.['address.backCTA'],
          type: 'left-arrow-v2',
          disabled: false,
        }"
        (utilityClicked)="bacToAccInfo()"
      ></gds-utility-action>
    </div>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <!--Address heading-->
    <gds-heading
      [data]="{
        heading: pageLabels?.['paymentInfo.heading'] ?? 'Payment Info',
      }"
      class="A3-W6"
    >
    </gds-heading>
    <!--Address description-->
    @if (paymentData.length > 0) {
      <gds-spacer classes="spacer-70"></gds-spacer>
      <!--Address list card-->
      @for (card of paymentData; track card) {
        <div class="card card-container" tabindex="0">
          <div class="payment-card">
            <gds-body
              [data]="{
                description: card?.is_primary
                  ? pageLabels?.['paymentInfo.primaryCreditCard']
                  : pageLabels?.['paymentInfo.creditCard'],
              }"
              class="B1-W4"
            ></gds-body>
            <div class="edit-cta">
              <!--Address list editCTA navigate to edit address page-->
              <gds-buttons
                [data]="{
                  type: 'tertiary',
                  href: '',
                  label: enableEditPayment
                    ? pageLabels?.['address.edit']
                    : pageLabels?.['deleteAcc.delete'],
                  disabled: false,
                  target: '',
                }"
                (buttonClicked)="editPaymentInfo(card)"
              >
              </gds-buttons>
            </div>
          </div>
          <div>
            <gds-spacer classes="spacer-30"></gds-spacer>
            <div class="payment-card-number">
              <div
                class="A6-W4 adventure"
                [attr.aria-label]="
                  pageLabels?.['cardType.' + card?.issuer_code] +
                  pageLabels?.['paymentInfo.card'] +
                  card?.last_four_digits
                "
              >
                <span class="right-padding">
                  {{ pageLabels?.['cardType.' + card?.issuer_code] }}
                </span>
              </div>
              <div class="A6-W4 adventure">
                @for (n of numSequence(10); track n) {
                  <span>&bull;</span>
                }
                <span>{{ card?.last_four_digits }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    }
    @if (enableEditPayment) {
      <gds-spacer classes="spacer-50"></gds-spacer>
      <gds-wrapper class="gds-wrapper gds-wrapper-flex add-visitor">
        <gds-utility-action
          [data]="{
            icon: {
              iconName: 'add',
            },
            label: pageLabels?.['paymentInfo.addCc'],
            type: 'add',
            ariaText: pageLabels?.['paymentInfo.addCc'],
            disabled: false,
          }"
          (click)="addPaymentInfo()"
        ></gds-utility-action>
      </gds-wrapper>
      <gds-spacer classes="spacer-70"></gds-spacer>
    }
    @if (paymentData.length === 0) {
      <gds-spacer classes="spacer-70"></gds-spacer>
      <div
        class="card"
        role="region"
        [attr.aria-label]="pageLabels?.['paymentInfo.emptyCreditCard']"
      >
        <gds-body
          [data]="{
            description: pageLabels?.['paymentInfo.emptyCreditCard'],
          }"
          class="B1-W4"
        ></gds-body>
      </div>
    }
    <gds-spacer classes="spacer-50"></gds-spacer>
    @if (showLoader) {
      <gds-loading
        [data]="{
          label: pageLabels?.['com.upr.general.loading.title'],
        }"
      >
      </gds-loading>
    }
  </div>
}
